// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-settings-control-forum-listing .description-limit-select {
  width: 100%;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget-settings/controls/forum-listing/forum-listing.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,eAAA;AAAR","sourcesContent":[".widget-settings-control-forum-listing {\r\n    .description-limit-select {\r\n        width: 100%;\r\n        margin-top: 5px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
